import apiService from './apiService';

const emailService = {
  // Get all emails for a lead
  async getLeadEmails(leadId, params = {}) {
    try {
      const response = await apiService.get(`/emails/lead/${leadId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching lead emails:', error);
      throw error;
    }
  },

  // Get all emails for a deal (fetches lead's emails via deal)
  async getDealEmails(dealId, params = {}) {
    try {
      const response = await apiService.get(`/emails/deal/${dealId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching deal emails:', error);
      throw error;
    }
  },

  // Get single email by ID
  async getEmail(emailId) {
    try {
      const response = await apiService.get(`/emails/${emailId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching email:', error);
      throw error;
    }
  },

  // Send new email
  async sendEmail(emailData) {
    try {
      const response = await apiService.post('/emails/send', emailData);
      return response.data;
    } catch (error) {
      console.error('Error sending email:', error);
      throw error;
    }
  },

  // Delete email
  async deleteEmail(emailId) {
    try {
      const response = await apiService.delete(`/emails/${emailId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting email:', error);
      throw error;
    }
  }
};

export default emailService;
